<template>
  <el-date-picker
    v-model="result"
    :type="type"
    :align="align"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :format="type === 'datetimerange'? 'yyyy-MM-dd HH:mm:ss': 'yyyy-MM-dd'"
    @change="dateChange"
    :disabled="disabled"
    :picker-options="pickerOptions">
  </el-date-picker>
</template>

<script>
import { parseTime } from '@/utils/formatTime'
export default {
  name: 'DateRangePicker',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // 快捷按钮数组
    options: {
      type: Array,
      default () {
        return ['today', 'yesterday', '7days', '30days', 'this month', 'last month']
      }
    },
    align: {
      type: String,
      default: 'left'
    },
    value: {
      type: Array,
      default () {
        return []
      }
    },
    maxMonth: {
      type: Number,
      default: 6
    },
    // 日期选择器类型，可选datetimerange及daterange
    type: {
      type: String,
      default: 'datetimerange'
    },
    // 能选择的最早时间戳，默认禁止选择5个月前数据，-1代表都不限制
    disabledBeforeDate: {
      type: Number,
      default: 0
    },
    // 能选择的最晚时间戳，默认不限制，-1代表都不限制
    disabledAfterDate: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      result: []
    }
  },
  watch: {
    value (val) {
      if (JSON.stringify(val) !== '[]') {
        this.result = val
        // this.dateChange(val);
      }
    }
  },
  computed: {
    pickerOptions () {
      const that = this
      const result = {
        disabledDate (time) {
          const now = new Date()
          let illegalBefore
          const illegalAfter = that.disabledAfterDate
          if (that.disabledBeforeDate !== 0) {
            illegalBefore = that.disabledBeforeDate
          } else {
            const illegalDate = new Date(now.setDate(0))
            illegalDate.setMonth(now.getMonth() - 5)
            illegalDate.setDate(0)
            illegalBefore = illegalDate.getTime() - 8.64e6
          }
          const disableResult = (illegalBefore < 0 ? false : time.getTime() < illegalBefore) || (illegalAfter === -1 ? false : time.getTime() > illegalAfter)
          return disableResult
        },
        shortcuts: []
      }
      if (this.options.includes('today')) {
        result.shortcuts.push({
          text: '今天',
          onClick (picker) {
            let end = new Date()
            let start = new Date()
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      if (this.options.includes('yesterday')) {
        result.shortcuts.push({
          text: '昨天',
          onClick (picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      if (this.options.includes('7days')) {
        result.shortcuts.push({
          text: '最近7天',
          onClick (picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      if (this.options.includes('30days')) {
        result.shortcuts.push({
          text: '最近30天',
          onClick (picker) {
            let end = new Date()
            let start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      if (this.options.includes('this month')) {
        result.shortcuts.push({
          text: '这个月',
          onClick (picker) {
            let end = new Date()
            let start = new Date()
            const year = start.getFullYear()
            const month = start.getMonth()
            start = new Date(year, month)
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      if (this.options.includes('last month')) {
        result.shortcuts.push({
          text: '上个月',
          onClick (picker) {
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()
            let start = new Date(year, month - 1)
            let end = new Date(now.setDate(0))// 传0是上一个月的最后一天
            start = that.formatStart(start)
            end = that.formatEnd(end)
            picker.$emit('pick', [start, end])
          }
        })
      }
      return result
    }
  },
  mounted () {
    if (JSON.stringify(this.value) !== '[]') {
      this.result = this.value
      console.log(this.result)
      // this.dateChange(this.result);
    }
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        // value[0] = value[0].getFullYear() + '-' + (((value[0].getMonth() + 1) < 10)  ? ('0'+ (value[0].getMonth() + 1)) : (value[0].getMonth() + 1))+ '-' + ((value[0].getDate() < 10) ? ('0' + value[0].getDate()) : (value[0].getDate())) + ' 00:00:00';
        // value[1] = value[1].getFullYear() + '-' + (((value[1].getMonth() + 1) < 10)  ? ('0'+ (value[1].getMonth() + 1)) : (value[1].getMonth() + 1)) + '-' + ((value[1].getDate() < 10) ? ('0' + value[1].getDate()) : (value[1].getDate())) + ' 23:59:59';
        if (this.type === 'datetimerange') {
          value[0] = parseTime(value[0], '{y}-{m}-{d} {h}:{i}:{s}')
          value[1] = parseTime(value[1], '{y}-{m}-{d} {h}:{i}:{s}')
        } else {
          value[0] = parseTime(value[0], '{y}-{m}-{d}')
          value[1] = parseTime(value[1], '{y}-{m}-{d}')
        }
        this.result = value
      } else {
        this.result = []
      }
      this.$emit('getChange', this.result)
    },
    formatStart (start) {
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)
      return start
    },
    formatEnd (end) {
      end.setHours(23)
      end.setMinutes(59)
      end.setSeconds(59)
      return end
    }
  }
}
</script>

<style scoped>

</style>
